import React,{useEffect} from 'react'
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb'
import AllAcountsSection from '../../Components/AllAccountsSection/AllAcountsSection'
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import { AiOutlineArrowRight } from "react-icons/ai";
import { question } from './BusinessFinanceData';
import BusinessFiananceAccordion from './BusinessFiananceAccordion';

// import Arrow_down from "../../assets/images/IZB/arrow_down.png";


const BusinessFinance = () => {
const Arrow_down = "https://izbassetsmain.blob.core.windows.net/izbwebassets/arrow_down.png";
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-finance-banner.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/businessfinance-2.png";
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const accountContent = "This is a specialised overdraft facility for business designed for business for quick working capital solutions backed by security."
  return (
    <>
    <Breadcrumb Heading="Business Finance" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
      <SavePlusAccountComponent
        heading="Business Finance"
        subHeading="Know About"
        content={accountContent}
        btnTxt="Apply Now"
        img={img1}
        logo={true}
      />

      <section
        className="page-contains-area"
        style={{ backgroundColor: "#FFF5E7" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="page-contains-box">
                <div className="page-contains-btn">
                  <ul className="navigation clearfix scroll-nav">
                    <li className="current">
                      <a href="#benefits">
                        <img src={Arrow_down} className="me-1" />
                        Eligibility
                      </a>
                    </li>
                 
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="MSMEAccodion">
        <div className="container justify-content-center mt-5">
          <div className="faq-style1__content">
            <ul className="accordion-box my-5">
              {question.map((item) => {
                const { id } = item;
                return <BusinessFiananceAccordion key={id} {...item} />;
              })}
            </ul>
          </div>
        </div>
      </section>
    <AllAcountsSection/>
    </>
  )
}

export default BusinessFinance